<template>
  <scatter-chart
    class="fill-height"
    :series="getSeries()"
    :xaxis="{ title: { text: $t('gps_variables.volume') }, min: 0 }"
    :yaxis="{ title: { text: $t('gps_variables.intensity') }, min: 0 }"
    :annotations="getAnnotations()"
    :loading="loading"
  >
    <template v-slot:header>
      <v-card-title class="pa-6 d-flex justify-space-between">
        <v-row
          dense
          align="center"
        >
          <v-col class="text-no-wrap">
            <div class="subtitle-2 grey--text text--grey-100">
              {{ $t('card_title.volume_and_intensity') }}
            </div>
          </v-col>
        </v-row>
        <v-btn
          v-if="removable"
          icon
          style="pointer-events: auto"
          @click="$emit('remove')"
        >
          <v-icon small>
            fal fa-times
          </v-icon>
        </v-btn>
      </v-card-title>
    </template>
  </scatter-chart>
</template>

<script>
import ScatterChart from '@/components/charts/ScatterChart.vue'

export default {
  name: 'VolumeIntensityScatterPeriodChart',
  components: { ScatterChart },
  props: {
    periods: {
      type: Array,
      required: true
    },
    chart: {
      type: Object,
      default: () => ({})
    },
    loading: {
      type: Boolean,
      default: false
    },
    removable: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    getSeries() {
      return [{
        name: 'Periods',
        data: this.periods.map(period => {
          return {
            x: period.teams[0]?.team_stats?.UXVOL || 0,
            y: period.teams[0]?.team_stats?.UXINTS || 0,
            name: period.title
          }
        })
      }]
    },
    getAnnotations() {
      const volValues = this.periods.map(p => p.teams[0]?.team_stats?.UXVOL || 0)
      const intsValues = this.periods.map(p => p.teams[0]?.team_stats?.UXINTS || 0)

      const maxVol = Math.max(...volValues) / 2
      const maxInts = Math.max(...intsValues) / 2

      return {
        xaxis: [{
          x: maxVol,
          strokeDashArray: 0,
          borderColor: '#008FFB'
        }],
        yaxis: [{
          y: maxInts,
          strokeDashArray: 0,
          borderColor: '#008FFB'
        }]
      }
    }
  }
}
</script>
